var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-exchange-rate-afir"},[_c('exchange-rate-afir-form',{attrs:{"version-info":_vm.versionInfo},on:{"on-version-change":_vm.setVersion,"on-date-change":_vm.dateChanged}}),_c('exchange-rate-afir-results',{attrs:{"date":_vm.date,"results":_vm.version}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }